import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TabsPage } from './tabs.page';

const routes: Routes = [
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: 'revo',
        loadChildren: () => import('./revolutions/revolutions.module').then( m => m.RevolutionsPageModule)
      },
      {
        path: 'revolutions',
        loadChildren: () => import('./revolutions/revolutions.module').then( m => m.RevolutionsPageModule)
      },
      {
        path: 'velocity',
        loadChildren: () => import('./velocity/velocity.module').then( m => m.VelocityPageModule)
      },
      {
        path: 'anvance',
        loadChildren: () => import('./avance/avance.module').then( m => m.AvancePageModule)
      },
      {
        path: 'marchuelos',
        loadChildren: () => import('./marchuelos/marchuelos.module').then( m => m.MarchuelosPageModule)
      }
    ]
  },
  {
    path: 'torneado',
    loadChildren: () => import('./torneado/torneado.module').then( m => m.TorneadoPageModule)
  },
  {
    path: 'angulos',
    loadChildren: () => import('./angulos/angulos.module').then( m => m.AngulosPageModule)
  },
  {
    path: 'contentfcm',
    loadChildren: () => import('./contentfcm/contentfcm.module').then( m => m.ContentfcmPageModule)
  },
  {
    path: 'rpm',
    loadChildren: () => import('./rpm/rpm.module').then( m => m.RpmPageModule)
  },
  {
    path: 'rpmmachuelos',
    loadChildren: () => import('./rpmmachuelos/rpmmachuelos.module').then( m => m.RpmmachuelosPageModule)
  },
  {
    path: 'brocas',
    loadChildren: () => import('./brocas/brocas.module').then( m => m.BrocasPageModule)
  },
  {
    path: 'tablas',
    loadChildren: () => import('./tablas/tablas.module').then( m => m.TablasPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TabsPageRoutingModule {}
